export default __webpack_public_path__ + "static/media/logi-tech.3104c691.svg";